import * as React from 'react';
import { RobotIcon } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export interface RobotRetryButtonProps {
  onClick: () => void | Promise<void>;
  isLoading?: boolean;
  disabled?: boolean;
  tooltip?: string;
  size?: 'sm' | 'default' | 'lg' | 'icon';
  variant?:
    'ghost' | 'default' | 'secondary' | 'destructive' | 'outline' | 'link';
  children?: React.ReactNode;
}

export function RobotRetryButton({
  onClick,
  isLoading = false,
  disabled = false,
  tooltip = 'Retry Matching',
  size = 'sm',
  variant = 'ghost',
  children,
}: RobotRetryButtonProps) {
  const handleClick = React.useCallback(() => {
    void onClick();
  }, [onClick]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant={variant}
          size={size}
          onClick={handleClick}
          disabled={disabled || isLoading}
        >
          <RobotIcon
            className={isLoading ? 'h-4 w-4 animate-spin' : 'h-4 w-4'}
          />
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{tooltip}</TooltipContent>
    </Tooltip>
  );
}
